import { fetchAPI } from "../../../../../config/axios";
import { PenurunanTingkatRisikoAction, PenurunanTingkatRisikoActionType, PenurunanTingkatRisikoDataModel } from "./types";

export const PenurunanTingkatRisiko: PenurunanTingkatRisikoDataModel = {
  main: {
    data: [],
    total: 0,
  },
};

export const PenurunanTingkatRisikoReducer = (
  state: PenurunanTingkatRisikoDataModel = PenurunanTingkatRisiko,
  action: PenurunanTingkatRisikoAction
): PenurunanTingkatRisikoDataModel => {
  switch (action.type) {
    case PenurunanTingkatRisikoActionType.GetPenurunanTingkatRisiko:
      return { ...state, main: action.data };
    default:
      return state;
  }
};

export const PenurunanTingkatRisikoCommand = {
  GetPenurunanTingkatRisiko: (params: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().get(
          "/tj-parameter-penilaian/penurunan-tingkat-risikos",
          { params }
        );
         
        dispatch({
          type: PenurunanTingkatRisikoActionType.GetPenurunanTingkatRisiko,
          data: {
            data: response.data.data,
            total: response.data.data?.length,
          },
        });
      } catch (error) {
        throw error;
      }
    };
  },
  CreatePenurunanTingkatRisiko: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().post(
          "/tj-parameter-penilaian/penurunan-tingkat-risiko",
          body
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  UpdatePenurunanTingkatRisiko: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().patch(
          "/tj-parameter-penilaian/penurunan-tingkat-risiko",
          body
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  DeletePenurunanTingkatRisiko: (params: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().delete(
          "/tj-parameter-penilaian/penurunan-tingkat-risiko",
          { params }
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
};
